import React, { useEffect, useState } from 'react';
import { useLocation } from "react-router-dom";
import ReportPopup from './ReportPopup';
import star_yell from "../../assets/icon/star_yell.svg";
import star_default from "../../assets/icon/star_gray.svg";
import { EMPLOYEE_EVALUATION_URL } from '../../utils/urls';
import instance from '../../services/services';
import PopupLoginError from './LoginError';
import { formatLocalString } from '../../utils/validation';

function ReviewPopup ({ isPopup, setIsPopup, type, order_seq, report_flag, point }){
  const location = useLocation();
  const [popupActive, setPopupActive] = useState(false);
  const [rentStaffRating, setRentStaffRating] = useState(0);    // 대여직원 평점
  const [equipmentRating, setEquipmentRating] = useState(0);    // 장비상태 평점
  const [returnStaffRating, setReturnStaffRating] = useState(0); // 반납직원 평점
  const [report, setReport] = useState();
  const [hide, setHide] = useState(false);
  const [rentServiceAttitude, setRentServiceAttitude] = useState(1); // 대여서비스태도 기본값 '보통'
  const [returnServiceAttitude, setReturnServiceAttitude] = useState(1); // 반납서비스태도 기본값 '보통'
  const [isPopupLoginError, setIsPopupLoginError] = useState(false);
  

  useEffect(() => {
      const body = document.body;
      body.style.overflow = isPopup ? 'hidden' : 'auto';
      return () => {
          body.style.overflow = 'auto';
      };
  }, [isPopup]);

  useEffect(() => {
      let timeout;
      if (isPopup) {
          timeout = setTimeout(() => {
              setPopupActive(true);
          }, 100);
      } else {
          setPopupActive(false);
      }
      return () => clearTimeout(timeout);
  }, [isPopup]);

  useEffect(() => {
      document.body.style.overflow = 'auto';
  }, [location]);

  // 상태 초기화 함수 추가
  const resetStates = () => {
    setRentStaffRating(0);
    setEquipmentRating(0);
    setReturnStaffRating(0);
    setHide(false);
    setRentServiceAttitude(1);
    setReturnServiceAttitude(1);
  };

  const handleClose = (e) => {
    e.preventDefault();
    resetStates();
    setIsPopup(false);
  };
  
  // 딤 배경 클릭 핸들러 추가
  const handleBackgroundClick = (e) => {
    if (e.target.className === 'popup-box-component') {
      resetStates();
      setIsPopup(false);
    }
  };

  const handleReport = () => {
    setReport(true);
  };

  const handleHide = () => {
    setHide(!hide);
  };

  const handleSubmit = () => {
    const fetchData = async () => {
      try {
        let requestData;

        if (hide) {
          requestData = {
            order_seq: order_seq,
            order_kind: type,
            rental_rating: 0,
            setup_rating: 0,
            return_rating: 0,
            rental_service_attitude: 0,
            return_service_attitude: 0,
            evaluated_flag: 'N'
          };
        } else if (type === 'parcel') {
          requestData = {
            order_seq: order_seq,
            order_kind: type,
            rental_rating: rentStaffRating,
            setup_rating: rentStaffRating,
            return_rating: rentStaffRating,
            rental_service_attitude: 0,
            return_service_attitude: 0,
            evaluated_flag: 'Y'
          };
        } else {
          requestData = {
            order_seq: order_seq,
            order_kind: type,
            rental_rating: rentStaffRating,
            setup_rating: equipmentRating,
            return_rating: returnStaffRating,
            rental_service_attitude: rentServiceAttitude,
            return_service_attitude: returnServiceAttitude,
            evaluated_flag: 'Y'
          };
        }

        const response = await instance.post(EMPLOYEE_EVALUATION_URL, requestData);
        
        if (response.data.code === 200) {
          setIsPopupLoginError({
            message: "평가가 완료되었습니다.",
            action: 'reload'
          });
          resetStates();
        }
      } catch (error) {
        console.error('직원평가 데이터 전송 실패:', error);
        setIsPopupLoginError({
          message: error.response?.data?.message || "평가 제출에 실패했습니다.",
          action: 'reload'
        });
      }
    };
    fetchData();
  };

  // 서비스 태도 라디오 버튼 핸들러 수정
  const handleRentServiceAttitude = (value) => {
    setRentServiceAttitude(value);
  };

  const handleReturnServiceAttitude = (value) => {
    setReturnServiceAttitude(value);
  };

  const handleConfirm = () => {
    resetStates();
    setIsPopup(false);
    if (isPopupLoginError.action === 'reload') {
      window.location.reload();
    }
  };

  if (isPopup)
    return (
        <div 
          className="popup-box-component"
          onClick={handleBackgroundClick}
        >
          <div className={`box content ${popupActive ? 'active' : ''}`}>
            <div className="popup_container">
              <div className='pop_title line flex-btw'>
                <h4>이용평가</h4>
              </div>
              <div className='close_btn_con'>
                <button 
                  type="button" 
                  className="close_btn"
                  onClick={handleClose}
                />
              </div>

              {/* 서비스 별점 평가 */}
              <div className={`pop_addr_con ${hide ? 'hide' : ''}`}>

                {type === 'visit' && (
                  <ul className="default_info_list address_list">
                    {/* 대여직원 태도 */}
                    <li className="info_item" >
                      <div className="delivery_info">
                        <div className="info_detail_16 column flex-justify-center gap_16">
                          <p className='strong_b1'>대여직원의 서비스에 만족하셨나요?</p>
                          <div className="column flex-center-8">
                            <p className='g-80 b2_1'>평점을 클릭해 주세요</p>
                            <ul className='rating_list review'>
                              {[1,2,3,4,5].map((star) => (
                                <li
                                  key = {star}
                                  onClick={() => setRentStaffRating(star)}
                                  style={{cursor : 'pointer'}}
                                >
                                  <img 
                                    src={rentStaffRating >= star ? star_yell : star_default} 
                                    alt="star"
                                    loading="lazy"
                                  />
                                </li>
                              ))}
                            </ul>
                          </div>
                          <div className="column flex-center-8">
                            <p className='g-80 b2_1'>해당하는 서비스 태도를 선택해 주세요</p>
                            <div className="default_radio radio_list">
                              <div>
                                <input 
                                  type="radio" 
                                  id="rent_attitude_kind" 
                                  value="1"
                                  name="rent_attitude"
                                  checked={rentServiceAttitude === 1}
                                  onChange={(e) => handleRentServiceAttitude(Number(e.target.value))}
                                />
                                <label htmlFor="rent_attitude_kind">친절</label>
                              </div>

                              <div>
                                <input 
                                  type="radio" 
                                  id="rent_attitude_normal" 
                                  value="2"
                                  name="rent_attitude"
                                  checked={rentServiceAttitude === 2}
                                  onChange={(e) => handleRentServiceAttitude(Number(e.target.value))}
                                />
                                <label htmlFor="rent_attitude_normal">보통</label>
                              </div>

                              <div>
                                <input 
                                  type="radio" 
                                  id="rent_attitude_rude" 
                                  value="3"
                                  name="rent_attitude"
                                  checked={rentServiceAttitude === 3}
                                  onChange={(e) => handleRentServiceAttitude(Number(e.target.value))}
                                />
                                <label htmlFor="rent_attitude_rude">불친절</label>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </li>

                    {/* 장비상태 */}
                    <li className="info_item" >
                      <div className="delivery_info">
                        <div className="info_detail_16 column flex-justify-center gap_16">
                          <p className='strong_b1'>장비세팅 상태에 만족하셨나요?</p>
                          <div className="column flex-center-8">
                            <p className='g-80 b2_1'>평점을 클릭해 주세요</p>
                            <ul className='rating_list review'>
                              {[1,2,3,4,5].map((star) => (
                                <li
                                  key = {star}
                                  onClick={() => setEquipmentRating(star)}
                                  style={{cursor : 'pointer'}}
                                >
                                  <img 
                                    src={equipmentRating >= star ? star_yell : star_default} 
                                    alt="star"
                                    loading="lazy"
                                  />
                                </li>
                              ))}
                            </ul>
                          </div>
                        </div>
                      </div>
                    </li>

                    {/* 반납직원 태도 */}
                    <li className="info_item" >
                      <div className="delivery_info">
                        <div className="info_detail_16 column flex-justify-center gap_16">
                          <p className='strong_b1'>반납직원의 서비스에 만족하셨나요?</p>
                          <div className="column flex-center-8">
                            <p className='g-80 b2_1'>평점을 클릭해 주세요</p>
                            <ul className='rating_list review'>
                              {[1,2,3,4,5].map((star) => (
                                <li
                                  key = {star}
                                  onClick={() => setReturnStaffRating(star)}
                                  style={{cursor : 'pointer'}}
                                >
                                  <img 
                                    src={returnStaffRating >= star ? star_yell : star_default} 
                                    alt="star"
                                    loading="lazy"
                                  />
                                </li>
                              ))}
                            </ul>
                            <div className="column flex-center-8">
                            <p className='g-80 b2_1'>해당하는 서비스 태도를 선택해 주세요</p>
                            <div className="default_radio radio_list">
                              <div>
                                <input 
                                  type="radio" 
                                  id="return_attitude_kind" 
                                  value="1"
                                  name="return_attitude"
                                  checked={returnServiceAttitude === 1}
                                  onChange={(e) => handleReturnServiceAttitude(Number(e.target.value))}
                                />
                                <label htmlFor="return_attitude_kind">친절</label>
                              </div>

                              <div>
                                <input 
                                  type="radio" 
                                  id="return_attitude_normal" 
                                  value="2"
                                  name="return_attitude"
                                  checked={returnServiceAttitude === 2}
                                  onChange={(e) => handleReturnServiceAttitude(Number(e.target.value))}
                                />
                                <label htmlFor="return_attitude_normal">보통</label>
                              </div>

                              <div>
                                <input 
                                  type="radio" 
                                  id="return_attitude_rude" 
                                  value="3"
                                  name="return_attitude"
                                  checked={returnServiceAttitude === 3}
                                  onChange={(e) => handleReturnServiceAttitude(Number(e.target.value))}
                                />
                                <label htmlFor="return_attitude_rude">불친절</label>
                              </div>
                            </div>
                          </div>
                          </div>
                        </div>
                      </div>
                    </li>
                  </ul>
                )}

                {type === 'parcel' && (
                  <ul className="default_info_list address_list">
                    <li className="info_item" >
                      <div className="delivery_info">
                        <div className="info_detail_16 column flex-justify-center gap_16">
                          <p className='strong_b1'>데이페이 전체 서비스에 만족하셨나요?</p>
                          <div className="column flex-center-8">
                            <p className='g-80 b2_1'>평점을 클릭해 주세요</p>
                            <ul className='rating_list review'>
                              {[1,2,3,4,5].map((star) => (
                                <li
                                  key = {star}
                                  onClick={() => setRentStaffRating(star)}
                                  style={{cursor : 'pointer'}}
                                >
                                  <img 
                                    src={rentStaffRating >= star ? star_yell : star_default} 
                                    alt="star"
                                    loading="lazy"
                                  />
                                </li>
                              ))}
                            </ul>
                          </div>
                        </div>
                      </div>
                    </li>
                  </ul>
                
                )}

              </div>

              {/* 이용평점 안내 */}
              <div className="bottom_info_box alert_box gray">
                <h6 className="strong_b1">이용 평점 안내</h6>
                <p className="px-4 dash_list flex-2 column">
                  <span className="guide_text_1 g-80">
                    이용평가를 완료하신 고객님께는 {point ? formatLocalString(Number(point)) : '0'}P를 적립해드립니다.
                  </span>
                  <span className="guide_text_1 g-80">
                    평점 부여는 반납 완료 후 10일 이내에 가능합니다.
                  </span>
                </p>
              </div>

              {/* 평가하지 않기 */}
              <div className="default_chk_box">
                <input 
                  type="checkbox"
                  id="attitude_none" 
                  checked={hide}  
                  onChange={handleHide}
                />
                <label htmlFor="attitude_none">
                  <span>
                    평가하지 않기
                  </span>
                </label>
              </div>

              <div className='pop_btn_wrap' style={{display: 'flex', gap: '4px' }}>
              {report_flag !== 'Y' && (
                  <button 
                      className='default_btn black pop_con_btn'
                      style={{cursor : 'pointer', color: 'red'}}
                      onClick={handleReport}
                  >
                      신고하기
                  </button>
              )}
                <button 
                  type="button"
                  className="default_btn black pop_con_btn" 
                  onClick={handleSubmit}
                >
                  제출하기
                </button>
              </div>
            </div>
          </div>
          <ReportPopup 
            isPopup={report} 
            setIsPopup={setReport} 
            order_seq={order_seq}
            report_flag={report_flag}
          />
          <PopupLoginError 
            isPopup={isPopupLoginError} 
            setIsPopup={setIsPopupLoginError}
            onConfirm={handleConfirm}
          />
        </div>
    );
};

export default ReviewPopup ;